export const iconFontAwesomeHouseholdPumpSoap = (
	<i className="fa-solid fa-pump-soap"></i>
);
